<ng-container *transloco="let t">
  <div class="flex h-full flex-col">
    <div class="min-h-0 flex-1 overflow-y-auto">
      {{
        t("self-service-transfer.account_transfer", [
          modalData.childOrganization.ownerUserName,
          parentOrganization()?.customerName,
        ])
      }}
      <div>
        <table class="table-sm table-hover table-striped mt-2 table">
          <thead>
            <tr>
              <th>{{ t("common.account") }}</th>
              <th>{{ t("common.marketplace") }}</th>
              <th>{{ t("self-service-transfer.target_account_group") }}</th>
            </tr>
          </thead>
          <tbody>
            @for (acc of modalData.accountMarketplaces; track acc) {
              <tr>
                <td class="text-left">
                  {{ acc.accountName }}
                </td>
                <td>
                  <IBadge [label]="acc.marketplace" size="xs" />
                </td>
                <td>
                  {{ targetAccountGroupName()?.get(acc.profileId!) }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div>
        @if (canBeTransferred()) {
          <ul>
            <li>
              {{ t("self-service-transfer.self_service_will_be_stopped", [modalData.childOrganization.ownerUserName]) }}
            </li>
            <li>{{ t("self-service-transfer.keep_readonly") }}</li>
            <li>{{ t("self-service-transfer.data_and_setup_tranfered") }}</li>
          </ul>
        } @else {
          <div class="alert alert-warning">
            {{ t("self-service-transfer.account_must_added_to_agency") }}
          </div>
        }
      </div>
    </div>
    <div class="modal-footer shrink-0">
      <button iButton variant="ghost" size="md" (click)="modalRef.close()">{{ t("common.cancel") }}</button>
      <button iButton size="md" [disabled]="!canBeTransferred()" [loading]="loading()" (click)="submit()">
        {{ t("self-service-transfer.transfer") }}
      </button>
    </div>
  </div>
</ng-container>
